import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits.js";

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { __privateAdd, __privateGet, __privateSet } from "./chunk-PXG64RU4.js"; // src/queryCache.ts

import { hashQueryKeyByOptions, matchQuery } from "./utils.js";
import { Query } from "./query.js";
import { notifyManager } from "./notifyManager.js";
import { Subscribable } from "./subscribable.js";

var _queries;

var QueryCache = /*#__PURE__*/function (_Subscribable) {
  function QueryCache() {
    var _this2;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, QueryCache);

    _this2 = _callSuper(this, QueryCache);
    _this2.config = config;

    __privateAdd(_this2, _queries);

    __privateSet(_this2, _queries, /* @__PURE__ */new Map());

    return _this2;
  }

  _inherits(QueryCache, _Subscribable);

  return _createClass(QueryCache, [{
    key: "build",
    value: function build(client, options, state) {
      var _options$queryHash;

      var queryKey = options.queryKey;
      var queryHash = (_options$queryHash = options.queryHash) !== null && _options$queryHash !== void 0 ? _options$queryHash : hashQueryKeyByOptions(queryKey, options);
      var query = this.get(queryHash);

      if (!query) {
        query = new Query({
          client: client,
          queryKey: queryKey,
          queryHash: queryHash,
          options: client.defaultQueryOptions(options),
          state: state,
          defaultOptions: client.getQueryDefaults(queryKey)
        });
        this.add(query);
      }

      return query;
    }
  }, {
    key: "add",
    value: function add(query) {
      if (!__privateGet(this, _queries).has(query.queryHash)) {
        __privateGet(this, _queries).set(query.queryHash, query);

        this.notify({
          type: "added",
          query: query
        });
      }
    }
  }, {
    key: "remove",
    value: function remove(query) {
      var queryInMap = __privateGet(this, _queries).get(query.queryHash);

      if (queryInMap) {
        query.destroy();

        if (queryInMap === query) {
          __privateGet(this, _queries).delete(query.queryHash);
        }

        this.notify({
          type: "removed",
          query: query
        });
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this3 = this;

      notifyManager.batch(function () {
        _this3.getAll().forEach(function (query) {
          _this3.remove(query);
        });
      });
    }
  }, {
    key: "get",
    value: function get(queryHash) {
      return __privateGet(this, _queries).get(queryHash);
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return _toConsumableArray(__privateGet(this, _queries).values());
    }
  }, {
    key: "find",
    value: function find(filters) {
      var defaultedFilters = _objectSpread({
        exact: true
      }, filters);

      return this.getAll().find(function (query) {
        return matchQuery(defaultedFilters, query);
      });
    }
  }, {
    key: "findAll",
    value: function findAll() {
      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var queries = this.getAll();
      return Object.keys(filters).length > 0 ? queries.filter(function (query) {
        return matchQuery(filters, query);
      }) : queries;
    }
  }, {
    key: "notify",
    value: function notify(event) {
      var _this4 = this;

      notifyManager.batch(function () {
        _this4.listeners.forEach(function (listener) {
          listener(event);
        });
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var _this5 = this;

      notifyManager.batch(function () {
        _this5.getAll().forEach(function (query) {
          query.onFocus();
        });
      });
    }
  }, {
    key: "onOnline",
    value: function onOnline() {
      var _this6 = this;

      notifyManager.batch(function () {
        _this6.getAll().forEach(function (query) {
          query.onOnline();
        });
      });
    }
  }]);
}(Subscribable);

_queries = new WeakMap();
export { QueryCache };